import pdf from "../../../../assets/MOCK_OD/img/pdf-svgrepo-com.svg";

import { useRef, useState, useContext, useReducer, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useHistory } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import { usePhoneValidation } from "../../../../Hooks/usePhoneValidation";
import { useSignature } from "../../../../Hooks/useSignature";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import ErrorMessage from "./ErrorMessageSign";
import GtmDataLayer from "../../../../Utility/GtmDataLayer";
import CheckBox2 from "./Checkbox2";

const SignV2 = ({
  basicDetailsValidation,
  setSignatureDataURL,
  setAgreement,
  setShowTMSClaimDoc,
  setShowCHClaimDoc,
  setShowLoa,
  setQuestionPdf,
  setShowTob,
  setShowDecl,
  setShowDsar,
  SetMockLoa,
  setShowChcWelcome,
  setShowChcLetterofAuthencity,
  setShowChcTob,
}) => {
  const initialState = {
    isAgreed: false,
    isCanvasEmpty: false,
    isValid: false,
    isChecked: false,
  };
  const signatureReducer = (state, action) => {
    switch (action.type) {
      case "signPadChange": {
        return {
          ...state,
          isCanvasEmpty: action.payload.value,
        };
      }
      case "validSignature": {
        return {
          ...state,
          isValid: action.payload.value,
        };
      }
      default:
        return state;
    }
  };
  const { phoneValidation } = usePhoneValidation();
  const { errors, register, setError, getValues } = useFormContext();
  const splitForm = useRef(null);
  const [state, dispatch] = useReducer(signatureReducer, initialState);
  const { saveSignature, isLoading } = useSignature();
  const history = useHistory();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const signPadRef = useRef();
  const formParameters = JSON.parse(localStorage.getItem("formData"));
  const message_type = "signature_store";
  const [signatureWrapWidth, setSignatureWrapWidth] = useState(0);
  const [signatureWrapHeight, setSignatureWrapHeight] = useState(0);
  const [isDisable, setIsDisable] = useState(false);
  const signatureWrapRef = useRef(null);
  const phoneNumber = getValues("txtPhone");
  const [isChecked, setIsChecked] = useState(true);
  const [checkboxtwo, setCheckboxtwo] = useState(true);
  const signDivRef = useRef(null);
  const [showDoc, setShowDoc] = useState(false);
  const [showTMSSubDocs, setShowTMSSubDocs] = useState(false);
  const [showCHSubDocs, setShowCHSubDocs] = useState(false);

  const validatePhoneNumber = async () => {
    const getPhoneValidation = await phoneValidation(phoneNumber);
    if (getPhoneValidation.data.status_code === 0) {
      setError("txtPhone", {
        type: "manual",
        message: "Please Enter Valid Working Phone Number",
      });
      document.getElementById("txtPhone").focus();
      return 0;
    } else if (getPhoneValidation.data.status_code === 2) {
      setError("txtPhone", {
        type: "manual",
        message: "Phone Number Already Exist",
      });
      document.getElementById("txtPhone").focus();

      return 0;
    } else if (getPhoneValidation.data.status_code === 3) {
      setError("txtPhone", {
        type: "manual",
        message: "Please Enter Valid Phone Number",
      });
      document.getElementById("txtPhone").focus();

      return 0;
    } else {
      return 1;
    }
  };
  const handleClick = async (e) => {
    const validcheck = await basicDetailsValidation();

    if (validcheck) {
      try {
        e.preventDefault();
        const signPad = signPadRef.current;
        if (signPad.isEmpty()) {
          return dispatch({ type: "signPadChange", payload: { value: true } });
        }

        const rpdata = signPad.toData();
        var signLength = 0;
        for (var i = 0; i < rpdata.length; i++) {
          signLength += Object.keys(rpdata[i]).length;
        }
        if (signLength > 13) {
          const validatePhone = await validatePhoneNumber();
          if (validatePhone) {
            const canvasDataURL = signPadRef.current
              .getCanvas()
              .toDataURL("image/png");
            setSignatureDataURL(canvasDataURL);
            GtmDataLayer({
              question: "signature",
            });
          }
        } else {
          signDivRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          return dispatch({ type: "validSignature", payload: { value: true } });
        }
      } catch (e) {
        console.warn(e);
      }
    }
  };

  useEffect(() => {
    if (!isChecked) {
      setAgreement(false);
    } else {
      setAgreement(true);
    }
  }, [isChecked]);

  useEffect(() => {
    function handleResize() {
      setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
      setSignatureWrapHeight(signatureWrapRef.current.clientHeight);
    }
    setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
    setSignatureWrapHeight(signatureWrapRef.current.clientHeight);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const clearSign = () => {
    if (signPadRef.current) signPadRef.current.clear();
  };

  const showTMS = () => {
    setShowTMSSubDocs((prevState) => !prevState); // Toggle between true and false
  };
  const showCH = () => {
    // setShowCHSubDocs((prevState) => !prevState);
    setShowCHClaimDoc(true);
  };

  const showLoa = () => {
    setShowLoa("show");
  };

  const showQuest = () => setQuestionPdf("show");
  const showTob = () => setShowTob("show");
  const showDecl = () => setShowDecl("show");
  const showDsar = () => setShowDsar("show");

  const showMockLoa = () => SetMockLoa(true);
  const showChcWelcome = () => setShowChcWelcome(true);
  const showChcLetterofAuthencity = () => setShowChcLetterofAuthencity(true);
  const showChcTob = () => setShowChcTob(true);

  return (
    <>
      <div className="sign-sec mb-2" ref={signDivRef}>
        <h5 className=" mb-2 mt-4">
          PLEASE SIGN IN THE BOX BELOW TO START YOUR CLAIM
        </h5>
        <CheckBox2
          dataId="checkbox2"
          anchorText=""
          anchorStyle=""
          href=""
          onChange={() => {
            setCheckboxtwo((prev) => !prev);
            dispatch({
              type: "privacyAgreed",
              payload: { value: checkboxtwo },
            });
          }}
          className="checkinput me-2"
          value={checkboxtwo}
          checked={checkboxtwo}
          CheckBoxText={
            <>
              I confirm that I had not maintained a positive balance for a
              significant period of <strong> time on my overdraft</strong>. This
              ought to have made the bank aware of my financial difficulties{" "}
              <strong>
                and that I could not clear the overdraft in a reasonable amount
                of time
              </strong>
              .&nbsp;
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowDoc(!showDoc);
                }}
              >
                View Claim Documents
              </a>
            </>
          }
        />

        {showDoc && (
          <div className="side-toggle bg-white px-3 py-2 mb-3 rounded-3 shadow-sm">
            <ul className="links ps-0 mt-0 mb-0">
              <li>
                <a className="btn btn-link fnt-sml" onClick={showLoa}>
                  <img src={pdf} />
                  Letter of Authority
                </a>
              </li>
              <li>
                <a className="btn btn-link fnt-sml" onClick={showQuest}>
                  <img src={pdf} />
                  Questionnaire
                </a>
              </li>
              <li>
                <a className="btn btn-link fnt-sml" onClick={showTob}>
                  <img src={pdf} />
                  Terms of Business Agreement
                </a>
              </li>
              <li>
                <a className="btn btn-link fnt-sml" onClick={showDecl}>
                  <img src={pdf} />
                  Declaration Form
                </a>
              </li>
              <li>
                <a className="btn btn-link fnt-sml" onClick={showDsar}>
                  <img src={pdf} />
                  DSAR Letter of Authority
                </a>
              </li>
            </ul>
          </div>
        )}
        <div className="signbox mt-2" ref={signatureWrapRef}>
          <SignatureCanvas
            canvasProps={{
              id: "myID",
              width: signatureWrapWidth,
              height: 200,
            }}
            ref={signPadRef}
            onEnd={() => {
              if (!signPadRef.current.isEmpty()) {
                dispatch({
                  type: "signPadChange",
                  payload: { value: false },
                });
                dispatch({
                  type: "validSignature",
                  payload: { value: false },
                });
              }
            }}
          />
        </div>
        <div className="">
          {state?.isCanvasEmpty && (
            <ErrorMessage errMessage="Signature is required!" />
          )}
          {state?.isValid && (
            <ErrorMessage errMessage="Draw valid signature!" />
          )}
        </div>
      </div>
      <div className="px-lg-0 px-md-0 px-sm-4 px-0 ">
        <CheckBox2
          dataId="checkbox1"
          anchorText=""
          anchorStyle=""
          href=""
          onChange={() => {
            setIsChecked(!isChecked);
            dispatch({
              type: "privacyAgreed",
              payload: { value: isChecked },
            });
          }}
          className="checkinput me-2"
          value={isChecked}
          checked={isChecked}
          CheckBoxText={
            <>
              I agree to the processing of my personal data as outlined below.
              I/We understand that <strong>TMS Legal</strong> will receive an
              Electronic Credit Report from CheckBoard and a soft footprint will
              be retained on my/our credit file.
            </>
          }
        />
      </div>
      <div className="d-flex justify-content-between clearfixxx">
        <input
          type="button"
          id=""
          name=""
          className="clearbutton"
          value="Clear"
          onClick={clearSign}
        />

        <button
          className=" btn-comm2 w-50 mb-lg-0 mb-md-0 mb-sm-0 mb-3 z-0"
          id="formSubmitBtn"
          name="formSubmitBtn"
          type="button"
          onClick={handleClick}
          disabled={isDisable}
        >
          <span>Start</span>
        </button>
      </div>

      <div className="sign-blowtext mt-2 mt-lg-3">
        <div className="text-cp">
          <p className="fw-semibold ">
            We respect your privacy and give you control over your personal
            data. Please review the information below before giving your
            consent.
          </p>
          <p className="fw-semibold">
            {" "}
            By ticking the box, you agree to the following :{" "}
          </p>
        </div>

        <p className="sig-title mb-1">Consent for Data Processing</p>
        <p>
          You consent to TMS Legal using your data to represent you in any 
          <strong> unaffordable/irresponsible </strong> Lending and/or Mis-Sold Car
          Finance claims.
        </p>

        <p className="sig-title mb-1">Withdrawal of Consent</p>
        <p>
          You can withdraw consent at any time by contacting us. Withdrawal of
          consent will not affect the legality of any processing carried out
          before your request.
        </p>

        <p className="sig-title mb-1">Optional Consent</p>
        <p>
          Your consent is voluntary and not a condition for accessing our
          services.
        </p>
      </div>
    </>
  );
};

export default SignV2;
